import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import throttle from 'lodash/throttle';
import styled from 'styled-components';
import classNames from 'classnames';
import Input from '../Input';
import { setRef } from '../utils/withForwardedRef';
var InputStyled = styled(Input)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & textarea {\n    resize: none;\n  }\n"], ["\n  & textarea {\n    resize: none;\n  }\n"])));

var TextArea = function TextArea(_a) {
  var label = _a.label,
      errorText = _a.errorText,
      message = _a.message,
      inputRef = _a.inputRef,
      onScroll = _a.onScroll,
      className = _a.className,
      other = __rest(_a, ["label", "errorText", "message", "inputRef", "onScroll", "className"]);

  var textareaRef = useRef(null);

  var _b = useState(true),
      showLabel = _b[0],
      setShowLabel = _b[1];

  var updateState = useMemo(function () {
    return throttle(function () {
      if (textareaRef.current) {
        setShowLabel(textareaRef.current.scrollTop <= 1);
      }
    }, 100);
  }, []);
  useEffect(function () {
    return function () {
      updateState.cancel();
    };
  }, [updateState]);
  var handleRef = useCallback(function (node) {
    if (inputRef) {
      setRef(inputRef, node);
    }

    textareaRef.current = node;
  }, [inputRef]);
  var handleScroll = useCallback(function (event) {
    if (onScroll) {
      onScroll(event);
    }

    updateState();
  }, [onScroll, updateState]);
  return _jsx(InputStyled, __assign({
    forwardedAs: TextareaAutosize,
    label: showLabel ? label : undefined,
    message: errorText || message,
    error: Boolean(errorText)
  }, other, {
    className: classNames(className, 'textarea'),
    ref: handleRef,
    onScroll: handleScroll
  }));
};

export default TextArea;
var templateObject_1;